<template>
  <div class="step1 section is-mobile-wider">
    <div class="container has-text-centered">
      <div
        class="coloumn column is-8 is-offset-2 is-12-mobile"
        v-if="isAreaEmpty"
      >
        <article class="message is-danger">
          <div class="message-header">
            <p>
              <span class="icon">
                <i class="mdi mdi-alert-circle mdi-12px"></i>
              </span>
              Verdammt! Leider sind schon alle Gläser verkauft!
            </p>
          </div>
          <div class="message-body">
            <p>
              Wir versuchen in der kommenden Blühsaison mehr Honig zu
              produzieren, unterstütze uns dafür gerne mit einer Patenschaft für
              das nächste Jahr!
            </p>
          </div>
        </article>
      </div>
      <div
        class="coloumn column is-8 is-offset-2 is-12-mobile"
        v-if="!isAreaEmpty"
        :class="thickclass"
      >
        <h3 class="subtitle is-4 is-size-5-mobile">
          Wie viele Gläser Honig aus der Blühsaison 2021 sollen es sein?
        </h3>
        <b-field>
          <b-slider
            size="is-large"
            type="is-info"
            class="spacetop spacebottom"
            v-model="qmslider"
            :custom-formatter="val => val + ' Gläser'"
            :min="0"
            :step="stepvalue"
            :max="slidermax"
          >
            <template v-for="val in [0, 2, 4, 6]">
              <b-slider-tick :value="val" :key="val">
                {{ val }}
              </b-slider-tick>
            </template>
          </b-slider>
        </b-field>
        <div class="content">
          <p class="is-size-6 is-size-7-mobile">
            Du kaufst
            <span class="has-text-weight-bold">{{ qmslider }} Gläser</span>
             mit je 250g Honig für einen Preis von:
            <span class="has-text-weight-bold" name="price">{{
              price | currency
            }}</span>
            (inkl. Versand; Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.).
          </p>
          <p>
            100 Gramm Honig kosten somit 3€. Wir versenden immer 2 Gläser in
            einem Paket, um nicht mehr Geld für den Versand als für das Produkt
            auszugeben. Außerdem ist die logistische Abwicklung so für uns um
            einiges einfacher. Eine Abholung vor Ort können wir leider nicht
            anbieten. Die Lieferung erfolgt innerhalb einer Woche.
          </p>
        </div>
        <div class="buttons is-right spacetop">
          <b-button
            type="is-primary"
            size="is-large"
            class="is-right"
            @click="forwardstep"
            :disabled="stepdisabled"
            >zu Schritt 2</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Step1",
  data() {
    return {
      qmslider: 2,
      slidermax: 6, // change value also in created() function
      stepvalue: 2,
      isAreaEmpty: false,
      stepdisabled: false,
      thickclass: "showthicks"
    };
  },
  methods: {
    forwardstep() {
      this.$emit("activeStep", 1);
      this.$matomo.trackEvent(
        "Honeyprocess",
        "Step1",
        "Selected: " + this.qmslider + " Gläser"
      );
    }
  },
  async created() {
    const area = await axios.get("/.netlify/functions/readhoneystock", {
      responseType: "json"
    });
    if (area.status === 200) {
      //console.log("Stock was read. Available packages: " + area.data.data.Honeystock);
      if (area.data.data.Honeystock < 6) {
        this.slidermax = area.data.data.Honeystock;
        this.thickclass = "hidethicks";
      }
      if (area.data.data.Honeystock < 1) {
        this.isAreaEmpty = true;
      }
    } else {
      //console.log("Could not read Stock");
    }
  },
  computed: {
    // Price is alsp calculated in payment functions for verification
    price: function() {
      switch (true) {
        case this.qmslider < 2:
          var pricecalc = Math.round(this.qmslider * 7.5 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          this.stepdisabled=true;
          return pricecalc;
        case this.qmslider < 10:
          var pricecalc = Math.round(this.qmslider * 7.5 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          this.stepdisabled=false;
          return pricecalc;
        default:
          var pricecalc = Math.round(this.qmslider * 7.5 * 100) / 100;
          this.$emit("qmprice", pricecalc);
          this.$emit("squaremeters", this.qmslider);
          this.stepdisabled=false;
          return pricecalc;
      }
    }
  }
};
</script>

<style lang="scss">
.b-slider.is-large .b-slider-tick-label {
  top: calc(1.5rem / 2 + 2px) !important;
}

.hidethicks .b-slider-tick-label {
  display: none !important;
}
</style>
